module.exports = __webpack_public_path__ + "static/media/logo_plain.1abe9817.png";